// extracted by mini-css-extract-plugin
module.exports = {"nav":"navbar-module--nav--7woBb","siteTitle":"navbar-module--siteTitle--29eM1","link":"navbar-module--link--1OSb9","footer":"navbar-module--footer--2KEIF"};